






import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import {colors} from '@/config';

More(Highcharts);

@Component({components: {Chart}})
export default class CompassIndustry extends Vue {
  @Prop() readonly rankings!: any;

  component: any = undefined;

  chartOptions: any = {
    chart: {
      polar: true,
      type: 'area',
      height: '69%',
      backgroundColor: 'transparent',
    },

    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    pane: {
      // size: '100%',
    },

    xAxis: {
      // tslint:disable-next-line:max-line-length
      categories: ['<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Avkastning') + '</span>', Vue.prototype.$t('Rörelsemarginal'), Vue.prototype.$t('Tillväxt'), '<span  style="font-weight: 600; color: black;">' + Vue.prototype.$t('Framtidsutsikter') + '</span>', Vue.prototype.$t('Soliditet'), Vue.prototype.$t('Rörelsekapital i % av omsättning'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Finansiell styrka') + '</span>', Vue.prototype.$t('Kassalikviditet'), Vue.prototype.$t('Räntetäckningsgrad'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Kortsiktig beredskap') + '</span>', Vue.prototype.$t('Riskbuffert'), Vue.prototype.$t('Räntabilitet på eget kapital')],
      tickmarkPlacement: 'on',
      lineWidth: 0,
      labels: {
        enabled: true,
        style: {
          fontSize: '1rem',
        },
        distance: 25,
      },
      plotLines: [{
        color: colors.Black,
        width: 2,
        value: 3,
        zIndex: 2,
      },
        {
          color: colors.Black,
          width: 2,
          value: 6,
          zIndex: 2,
        },
        {
          color: colors.Black,
          width: 2,
          value: 9,
          zIndex: 2,
        },
        {
          color: colors.Black,
          width: 2,
          value: 12,
          zIndex: 2,
        },
      ],
      gridLineColor: colors.LightGrey,
    },

    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
      max: 100,
      tickInterval: 10,
      gridLineColor: colors.LightGrey,
      gridLineDashStyle: 'longdash',
      labels: {
        enabled: false,
      },
    },

    tooltip: {
      shared: true,
      useHTML: true,
      positioner: () => {
        return {
          x: -100000,
          y: -100000,
        };
      },
    },

    legend: {
      reversed: false,
      enabled: true,
      floating: true,
      borderWidth: 1,
      padding: 16,
      backgroundColor: colors.Light,
      align: 'left',
      verticalAlign: 'top',
      x: 0,
      y: 0,
      layout: 'vertical',
      itemStyle: {
        font: '1rem Assistant, Verdana, sans-serif',
      },
    },

    plotOptions: {
      series: {
        animation: false,
        fillOpacity: 0.5,
        marker: {
          radius: 0,
          states: {
            hover: {
              radius: 5,
            },
          },
          symbol: 'circle',
        },
        lineWidth: 1,
        pointPlacement: 'on',
        point: {
          events: {
            mouseOver: this.onMouseOver,
          },
        },
        events: {
          mouseOut: this.onMouseOut,
        },
      },
    },

    series: [],
  };

  onMouseOver(e: any) {
    const i = e.target.index;
    const series = this.chartOptions.series;
    const res = {
      name: series[0].data[i].name,
      definition: this.getDefinition(i),
      points: [
        {
          name: series[0].name,
          keyValue: series[0].data[i].keyfigure,
          index: series[0].data[i].y,
        },
        {
          name: series[1].name,
          keyValue: series[1].data[i].keyfigure,
          index: series[1].data[i].y,
        },
        {
          name: series[2].name,
          keyValue: series[2].data[i].keyfigure,
          index: series[2].data[i].y,
        },
        {
          name: series[3].name,
          keyValue: series[3].data[i].keyfigure,
          index: series[3].data[i].y,
        },
      ],
    };
    this.component.$emit('hover', res);
  }

  onMouseOut() {
    this.component.$emit('hover', null);
  }

  getDefinition(i: number): string {
    switch (i) {
      case 1:
        return Vue.prototype.$t('Rörelseresultat efter avskrivningar i procent av nettoomsättningen. Nyckeltalet anger hur stor andel i procent av varje försäljningskrona som blir kvar för att täcka räntor, skatt samt skapa vinst.');
      case 2:
        return Vue.prototype.$t('Procentuell förändring (justerad till tolvmånadersperiod) mellan föregående och innevarande års nettoomsättning. Nyckeltalet visar hur mycket företaget ökar eller minskar sin försäljning.');
      case 4:
        return Vue.prototype.$t('Justerat eget kapital (eget kapital + beskattad del av obeskattade reserver) i procent av balansomslutningen. Nyckeltalet visar på bolagets finansiella stabilitet och långsiktiga överlevnadsförmåga.');
      case 5:
        return Vue.prototype.$t('Omsättningstillgångar minskat med kortfristiga skulder i procent av nettoomsättningen. Nyckeltalet används bl.a. för att uppskatta bolagets kapitalbehov vid en expansion.');
      case 7:
        return Vue.prototype.$t('Omsättningstillgångar exklusive lager och pågående arbete i procent av kortfristiga skulder. Nyckeltalet visar på bolagets betalningsförmåga på kort sikt.');
      case 8:
        return Vue.prototype.$t('Rörelseresultat efter avskrivningar plus finansiella intäkter som multipel av finansiella kostnader. Nyckeltalet anger vilken förmåga bolaget har att täcka sina räntekostnader.');
      case 10:
        return Vue.prototype.$t('Skillnaden i procent mellan avkastning på totalt kapital och genomsnittlig skuldränta. Nyckeltalet visar med hur mycket bolagets totala avkastning överstiger de räntekostnader de betalar.');
      case 11:
        return Vue.prototype.$t('Resultat efter finansiella intäkter och kostnader i procent av justerat eget kapital (eget kapital + beskattade del av obeskattade reserver). Nyckeltalet visar bolagets avkastning på ägarnas insatta kapital.');
      default:
        return '';
    }
  }

  @Watch('rankings', { immediate: true, deep: true })
  onRankingsChanged() {
    if (this.rankings === undefined) {
      return;
    }
    if (this.rankings.sheets === undefined) {
      return;
    }

    const sheet = this.rankings.sheets[0];

    const s1 = this.addData({
      name: `${sheet.DATE_TO.substring(0, 7)} (${sheet.MONTHS} ${Vue.prototype.$t('mån')})`,
      pointPlacement: 'on',
      fillOpacity: 0.5,
      color: colors.Primary,
      zIndex: 20,
      marker: {
        enabled: false,
        symbol: 'circle',
        fillColor: colors.Primary,
        lineWidth: 2,
        lineColor: null, // inherit from series
      },
    }, sheet.ranks, sheet.keyValues);

    const industry = this.addData({
      name: Vue.prototype.$t('Branschmedian'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.DarkGrey,
      dashStyle: 'longdash',
      zIndex: 15,
    }, sheet.industryRanks, sheet.industryKeyValues);

    const industry25 = this.addData({
      name: Vue.prototype.$t('Undre kvartil'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.Negative,
      lineColor: colors.Negative,
      zIndex: 10,
    }, sheet.industryRanks25, sheet.industryKeyValues25);

    const industry75 = this.addData({
      name: Vue.prototype.$t('Övre kvartil'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.Positive,
      lineColor: colors.Positive,
      zIndex: 5,
    }, sheet.industryRanks75, sheet.industryKeyValues75);

    const industryArea = {
      name: 'Area',
      showInLegend: false,
      fillOpacity: 0.5,
      color: colors.LightGrey,
      zIndex: 1,
      data: [
        [1, sheet.industryRanks25.operatingMargin],
        [2, sheet.industryRanks25.growth],
        [3, sheet.industryRanks25.longTerm],
        [4, sheet.industryRanks25.solidity],
        [5, sheet.industryRanks25.workingCapitalPct],
        [6, sheet.industryRanks25.financialStrength],
        [7, sheet.industryRanks25.quickRatio],
        [8, sheet.industryRanks25.interestCoverage],
        [9, sheet.industryRanks25.shortTerm],
        [10, sheet.industryRanks25.riskBuffer],
        [11, sheet.industryRanks25.returnOnCapital],
        [0, sheet.industryRanks25.yield],
        [1, sheet.industryRanks25.operatingMargin],
        [1, sheet.industryRanks75.operatingMargin],
        [0, sheet.industryRanks75.yield],
        [11, sheet.industryRanks75.returnOnCapital],
        [10, sheet.industryRanks75.riskBuffer],
        [9, sheet.industryRanks75.shortTerm],
        [8, sheet.industryRanks75.interestCoverage],
        [7, sheet.industryRanks75.quickRatio],
        [6, sheet.industryRanks75.financialStrength],
        [5, sheet.industryRanks75.workingCapitalPct],
        [4, sheet.industryRanks75.solidity],
        [3, sheet.industryRanks75.longTerm],
        [2, sheet.industryRanks75.growth],
        [1, sheet.industryRanks75.operatingMargin],
      ],
    };

    this.chartOptions.series = [s1, industry25, industry, industry75, industryArea];
  }

  addData(series: any, ranks: any, kv: any) {
    series.data = [
      {
        name: Vue.prototype.$t('Avkastning'),
        y: ranks.yield,
        keyfigure: null,
      },
      {
        name: Vue.prototype.$t('Rörelsemarginal'),
        y: ranks.operatingMargin,
        keyfigure: this.filters.P(kv.operatingMargin / 100.0),
      },
      {
        name: Vue.prototype.$t('Tillväxt'),
        y: ranks.growth,
        keyfigure: this.filters.P(kv.growth / 100.0),
      },
      {
        name: Vue.prototype.$t('Framtidsutsikter'),
        y: ranks.longTerm,
        keyfigure: null,
      },
      {
        name: Vue.prototype.$t('Soliditet'),
        y: ranks.solidity,
        keyfigure: this.filters.P(kv.solidity / 100.0),
      },
      {
        name: Vue.prototype.$t('Rörelsekapital i % av omsättning'),
        y: ranks.workingCapitalPct,
        keyfigure: this.filters.P(kv.workingCapitalPct / 100.0),
      },
      {
        name: Vue.prototype.$t('Finansiell styrka'),
        y: ranks.financialStrength,
        keyfigure: null,
      },
      {
        name: Vue.prototype.$t('Kassalikviditet'),
        y: ranks.quickRatio,
        keyfigure: this.filters.P(kv.quickRatio / 100.0),
      },
      {
        name: Vue.prototype.$t('Räntetäckningsgrad'),
        y: ranks.interestCoverage,
        keyfigure: this.filters.GGR(kv.interestCoverage) + Vue.prototype.$t(' ggr'),
      },
      {
        name: Vue.prototype.$t('Kortsiktig beredskap'),
        y: ranks.shortTerm,
        keyfigure: null,
      },
      {
        name: Vue.prototype.$t('Riskbuffert'),
        y: ranks.riskBuffer,
        keyfigure: this.filters.P(kv.riskBuffer / 100.0),
      },
      {
        name: Vue.prototype.$t('Räntabilitet på eget kapital'),
        y: ranks.returnOnCapital,
        keyfigure: this.filters.P(kv.returnOnCapital / 100.0),
      },
    ];
    return series;
  }

  created() {
    this.component = this;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    // this.chartOptions.chart.spacingLeft = this.vw(20);
  }

  vw(vw: number): number {
    return window.innerWidth * vw / 100.0;
  }

  get filters(): any {
    return (Vue as any).options.filters;
  }
}


